
export class VMUser {
    id: string | undefined;
    uname: string | undefined;
}

export class VMEventInput {
    labels: VMLabelNote[] = [];
}

export class VMLabelNote {
    name: string | undefined;
    id: number | undefined;
    parent: VMLabelNote = new VMLabelNote;
    nodes: VMLabelNote[] = [];
    events: VMEvent[] = [];
}

export class VMEvent {
    id: number | undefined;
    name: string | undefined;
    type: number | undefined;
    labelId: number | undefined;
    labelName: string | undefined;
    buttonNo: number | undefined;
    eventCell: Cell = new Cell;
    userId: string | undefined;
}

export class Cell {
    id: number | undefined;
    name: string | undefined;
}